import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3840387a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sec-pad position-relative",
  style: {"padding-top":"100px"}
}
const _hoisted_2 = { class: "container index-up" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "contactusblockpair-1 shadow roundimg" }
const _hoisted_6 = {
  class: "infoblockz sw-bg-3-wave",
  style: {"background":"white","margin-top":"25px"}
}
const _hoisted_7 = {
  key: 0,
  class: "contactinfodivv"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/statics/images/empty@2x.png",
  style: {"height":"220px","width":"240px"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "contactinfodivv",
  style: {"display":"flex","flex-wrap":"wrap","width":"100%"}
}
const _hoisted_11 = {
  class: "con-block-sw-div",
  style: {"min-height":"100px","width":"100%"}
}
const _hoisted_12 = { style: {"display":"flex"} }
const _hoisted_13 = { style: {"display":"flex"} }
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 4 }

import { ref,toRaw,reactive, onMounted, watch, onBeforeUnmount} from 'vue';
    import { useRouter } from 'vue-router';
    import { genFileId ,ElMessage,ElLoading} from 'element-plus';
    import type { UploadFile, UploadInstance, UploadProps, UploadRawFile,ElProgress } from 'element-plus';
    import { checkListGetall, getProgress, judgeChecklist} from "../api/modules/api.checklist";
    import {getList,create,downloadExcel} from "../api/modules/api.upload";
    import dbUtils from '../libs/util.strotage.js'
    import {authIsLogin} from '../api/modules/api.auth.js';

    
  const __default__ = {
    name: 'CheckListView',
  };
  
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

    const tableData = ref([]);
    const total = ref(0);
    const pageSize = ref(10);
    const currentPage = ref(1);
    const router = useRouter();
    const userInfo = dbUtils.get('FrontuserInfo')
    let uploadsIds = dbUtils.get("UploadsIds")
    const ifLogin = ()=>{
        authIsLogin().then(res => {
            console.log(res)
            if(!res.data){
                dbUtils.remove("FrontuserInfo") //去掉登录信息
            }
            fetchData();
        })
    }
    const fetchData = async (page = 1) => {
        try {
            let p = {
                pagination:{"current":page,
                            "pageSize":pageSize.value
                }
            }
            if(!userInfo){
                p["params"] = {}
                p["params"]["id"] = [null]
                if(uploadsIds){
                    p["params"]["id"] = uploadsIds.slice(0,10) //最多10个
                }
                

            }
            getList(p).then(res => {
                state.loading.spinning = false
                let datas = res.data.result
                
                tableData.value = datas
                total.value = res.data.total
                state.query.pagination.current = res.data.current
                state.query.pagination.pageSize = res.data.pageSize
            }).catch(err => {
                state.loading.spinning = false
                console.log(err)
            })
        
       
        } catch (error) {
        ElMessage.error('获取数据失败');
        }
    };
    const get_progress = ()=>{
        getProgress().then(res => {
            const keys1 = Object.keys(state.progressData);
            const keys2 = Object.keys(res.data);
            if(JSON.stringify(keys1) !== JSON.stringify(keys2)){
                fetchData(currentPage.value);
            }
            state.progressData = res.data
        })
    };
    const state = reactive({
      progressData:{},
      show: {
        add: false,
        edit: false,
        view: false
      },
      activeComponent: null,
      // 暂存更新数据
      updateData: {},
      // 暂存查看数据
      viewData: {},
      dataList: [],
      // 请求参数
      query: {
        params: {},
        pagination: {
          current: 1,
          pageSize: 5,
          total: 0,
          hideOnSinglePage: true,
        },
        sort: {
          columnKey: "createdAt",
          order: "ascend"
        }
      },
      // loading
      loading: {
        spinning: false,
        tip: '加载中'
      }
    })
    let timer
    let timer2
  const fileName = ref('')
  const upload = ref<UploadInstance>()
  const fileUp = ref()
 
  const handleCurrentChange = (page) => {
      currentPage.value = page;
      fetchData(page);
    };

  
  const gotoDetail = (item, items)=>{
    //router.push({ name: 'Detail', params: { id: items.id } });
    const url = `/detail/${items.id}`;
    window.open(url, '_blank');
  }

    const startRefreshing = () => {
        
        timer = setInterval(() => {
            fetchData(currentPage.value);
        }, 1000*60); // 每 60 秒刷新一次
        timer2 = setInterval(() => {
            get_progress()
        }, 1000*10); // 每 10 秒刷新一次
    };

    const stopRefreshing = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
       
        if(timer2){
            clearInterval(timer2);
            timer2 = null;
        }
    };
   
    // 当组件挂载时，尝试从localStorage读取保存的选择值
    onMounted(() => {
        ifLogin();
       
        startRefreshing();
    });
    onBeforeUnmount(() => {
      stopRefreshing();
    });

  
return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (tableData.value.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_table, {
                          data: tableData.value,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "filename",
                              label: "File Name"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "promptInfo.name",
                              label: "Checklist"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Upload time",
                              width: "160"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("span", null, _toDisplayString(new Date(scope.row.createdAt).toLocaleString()), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "Update time" }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("span", null, _toDisplayString(new Date(scope.row.updatedAt).toLocaleString()), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "Status" }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_14, [
                                  (state.progressData[scope.row.id])
                                    ? (_openBlock(), _createBlock(_component_el_progress, {
                                        key: 0,
                                        type: "circle",
                                        width: "45",
                                        percentage: state.progressData[scope.row.id],
                                        "stroke-width": 6
                                      }, null, 8, ["percentage"]))
                                    : (scope.row.status === '4')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Pending"))
                                      : (scope.row.status === '1')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Pending"))
                                        : (scope.row.status === '2')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Completed"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_18, "Error"))
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "Operation" }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_el_button, {
                                  link: "",
                                  size: "small",
                                  style: _normalizeStyle({
                                                    border: 0, 
                                                    color: scope.row.status === '2' ? '#04A3AE' : '#B0B0B0', 
                                                    cursor: scope.row.status === '2' ? 'pointer' : 'not-allowed'
                                                }),
                                  disabled: scope.row.status !== '2',
                                  onClick: ($event: any) => (gotoDetail(scope.$index, scope.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Detail ")
                                  ]),
                                  _: 2
                                }, 1032, ["style", "disabled", "onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]),
                        _createVNode(_component_el_pagination, {
                          background: "",
                          layout: "prev, pager, next",
                          total: total.value,
                          "page-size": pageSize.value,
                          "current-page": currentPage.value,
                          onCurrentChange: handleCurrentChange,
                          style: {"margin-top":"10px","float":"right"}
                        }, null, 8, ["total", "page-size", "current-page"])
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})